import React from "react";

const TipoImagenRotacion = ({ pregunta, onResponder, className = "" }) => {
  return (
    <>
      {pregunta.imagenPregunta && (
        <div className={`pregunta-imagen ${className}`}>
          <img
            src={
              typeof pregunta.imagenPregunta === "object"
                ? pregunta.imagenPregunta.src
                : pregunta.imagenPregunta
            }
            alt="Pregunta"
            style={{
              width:
                typeof pregunta.imagenPregunta === "object"
                  ? `${pregunta.imagenPregunta.tamaño}px`
                  : "auto",
              transform:
                typeof pregunta.imagenPregunta === "object"
                  ? `rotate(${pregunta.imagenPregunta.rotacion}deg)`
                  : "none",
            }}
          />
        </div>
      )}

      <p className={`pregunta-texto ${className}`}>{pregunta.texto}</p>

      <div className="opciones-imagenes">
        {pregunta.opciones.map((opcion, index) => {
          const esImagen =
            typeof opcion.imagen === "object" ||
            (typeof opcion.imagen === "string" && opcion.imagen.length > 50);

          return (
            <button
              key={index}
              className="opcion-imagen"
              onClick={() => onResponder(index)}
            >
              {esImagen ? (
                <img
                  src={
                    typeof opcion.imagen === "object"
                      ? opcion.imagen
                      : opcion.imagen
                  }
                  alt={`Opción ${index + 1}`}
                  style={{ transform: `rotate(${opcion.rotacion}deg)` }}
                  className="imagen-rotate-options"
                />
              ) : (
                <span
                  className="num-opcion"
                  style={{
                    transform: `rotate(${opcion.rotacion}deg)`,
                    display: "inline-block",
                  }}
                >
                  {opcion.imagen}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </>
  );
};

export default TipoImagenRotacion;